// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wGvOs","input":"styles_input__38doB"};